import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

const initialState = {
  data: {},
  loading: false,
};

const PatientUserSlice = createSlice({
  name: 'patientuser',
  initialState,
  reducers: {
    setPatientUser: (state, action) => {
      state.data = action?.payload;
    },
    removePatientUser: (state, action) => {
      state.data = {};
    },
    setPatientRewardPoints: (state, action) => {
      state.data.credit.points = action?.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(PURGE, (state) => {
      return initialState;
    });
  },
});

export const { setPatientUser, removePatientUser, setPatientRewardPoints } = PatientUserSlice.actions;
export default PatientUserSlice.reducer;
